<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <!-- content-header component -->
            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="card">

                <!-- TABELA DE DADOS -->
                <section id="ngx-datatable-inline-editing">
                    <!-- FUNCOES DA TABELA -->
                    <div class="row">
                        <div class="col-12">
                            <!-- <button class="btn btn-primary float-right mr-1 mt-1" routerLink="/contrato/cadastro" rippleEffect>
                                <i data-feather="plus" class="mr-0 mr-sm-1"></i><span
                                    class="d-none d-sm-inline-block">Novo <b>contrato</b></span>
                            </button> -->
                            <!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
                                        CSV</a> -->
                        </div>
                    </div>
                    <!-- FILTROS DA TABELA -->
                    <ng-template #customLoadingIndicator>
                        <div class="custom-loading-indicator">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </ng-template>

                    <!-- DATATABLE -->
                    <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                        [reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
                        [loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>ID Contrato</h4>
                                <input type="search" placeholder="ID Contrato" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'num_contrato')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.num_contrato}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>CPF/CNPJ</h4>
                                <input type="search" placeholder="Pesquisar CPF/CNPJ" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'cpf_cnpj')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.id_tipo == 1 ? '-': row.cpf_cnpj}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Nome Fantasia</h4>
                                <input type="search" placeholder="Pesquisar Nome Fantasia" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'nome_fantasia')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.id_tipo == 1 ? 'Grupo 2E': row.nome_fantasia}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Data Cadastro</h4>
                                <input type="search" placeholder="Pesquisar Data" class="ml-25 form-control"
                                    mask="00/00/0000" (keyup)="dateFilter($event)" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.dt_insert | date:'dd/MM/yyyy HH:mm':'UTC'}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <!-- <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Tipo</h4>
                                <input type="search" placeholder="Pesquisar Tipo" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'id_tipo')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
								<span class="badge badge-pill badge-light-dark" *ngIf="row.id_tipo == 1">Entrada</span>
								<span class="badge badge-pill badge-light-dark" *ngIf="row.id_tipo == 2">Saída</span>
                            </ng-template>
                        </ngx-datatable-column> -->

                        <!-- COLUNA -->
                        <!-- <ngx-datatable-column [width]="20" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <div class="d-flex align-items-center" style="float: right">
                                    <div ngbDropdown container="body">
                                        <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
                                            id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            <i data-feather="more-vertical"
                                                class="text-primary cursor-pointer mr-50"></i>
                                        </a>
                                        <div ngbDropdownMenu class="dropdown-menu-right"
                                            aria-labelledby="dropdownBrowserState">
                                            <a routerLink="/contrato/gerenciar/{{row.id_contrato}}" ngbDropdownItem
                                                class="d-flex align-items-center"><i data-feather="settings"
                                                    class="mr-50"></i> Gerenciar</a>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column> -->

                    </ngx-datatable>
                </section>

            </div>
        </div>
    </div>